<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxContactCell from "../../../../../../_shared/_modules/inbox-contact-cell"
  import type { CustomerSourceCleanupDraft, CustomerSourceCleanupRow } from "../../contract"

  let {
    row,
    disabled,
  }: InboxWorkflowCellProps<CustomerSourceCleanupRow, CustomerSourceCleanupDraft> = $props()
</script>

<InboxContactCell
  label={row.customerLabel}
  email={row.customerEmail}
  phone={row.customerPhone}
  unitLabel={row.unitLabel}
  {disabled}
/>
